import colors from './colors';
import typography from './typography';
import sizing from './sizing';
import inputs from './inputs';
import borders from './borders';
import utility from './utility';
import graphics from './graphics';
const defaultTheme = {
    colors,
    typography,
    sizing,
    inputs,
    borders,
    utility,
    borderRadius: {
        regular: '1rem',
        large: '50%'
    },
    graphics,
    isWebView: false
};
export default defaultTheme;
//# sourceMappingURL=index.js.map